import Image from 'next/image'
import { useRouter } from 'next/router'
import React from 'react'
import { useDispatch } from 'react-redux'
import { prependAssetHostItem } from 'src/common/utils'
import { saveOptionSelection, updateOptionClicked } from 'src/store/joinevent'

interface RaceProductDetailProps {
    currentItem: {
        challengeAddonAsset: {
            imageUri: string
        }
        itemPrice: number | string
        itemName: string
        itemDescription: string
        challengeAddonId: number | string
        challengeAddonOptions: any[]
        challengeAddonOptionId: number | string
    }
    challengeId: string
    isAlreadyJoined: boolean
}

export const RaceProductDetail = ({
    currentItem,
    challengeId,
    isAlreadyJoined
}: RaceProductDetailProps) => {
    const dispatch = useDispatch()
    const router = useRouter()

    const onOptionClicked = (optionId, displayText) => {
        dispatch(
            updateOptionClicked({
                challengeAddonId: currentItem.challengeAddonId,
                displayText,
                optionId
            })
        )
    }

    const onSaveRewardOptionsClicked = () => {
        if (currentItem.challengeAddonOptions.length > 0) {
            if (currentItem.challengeAddonOptionId === null) return
        }

        dispatch(
            saveOptionSelection({
                challengeAddonId: currentItem.challengeAddonId
            })
        )

        if (isAlreadyJoined) {
            void router.push(`/races/${challengeId}/rewards`, null, {
                shallow: true
            })
        } else {
            void router.push(`/races/${challengeId}#rewards`, null, {
                shallow: true
            })
        }
    }

    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-2 px-5 pt-10 mb-10 gap-x-8">
                <div className="relative flex items-center justify-center">
                    <div className="flex flex-col-reverse md:flex-row">
                        <div className="mr-8 my-8 md:my-0">
                            <div className="border-2 border-yf-green border-solid rounded-md max-w-[100px]">
                                <Image
                                    className="bg-gray-300 cursor-pointer rounded-md object-contain"
                                    width={145}
                                    height={145}
                                    src={prependAssetHostItem(
                                        currentItem.challengeAddonAsset.imageUri
                                    )}
                                />
                            </div>
                        </div>
                        <Image
                            className="bg-gray-300 object-contain"
                            width={800}
                            height={800}
                            src={prependAssetHostItem(
                                currentItem.challengeAddonAsset.imageUri
                            )}
                        />
                    </div>
                </div>
                <div className="px-5">
                    <h1 className="text-3xl font-medium mb-2">{currentItem.itemName}</h1>
                    <p className="text-2xl text-yf-green mb-8">
                        ${currentItem.itemPrice}
                    </p>

                    <div className="mb-8 flex justify-between">
                        <p className="text-gray-600 text-lg w-1/2 sm:w-auto">
                            Materials:
                        </p>
                        <p className="text-lg w-1/2 sm:w-auto">
                            {currentItem.itemDescription}
                        </p>
                    </div>

                    {currentItem.challengeAddonOptions.length ? (
                        <div className="mb-8 box-content flex flex-row justify-between items-center">
                            <p className="text-gray-600 text-lg w-1/3">Options:</p>

                            <div className="flex content-end items-end flex-wrap w-full max-w-[165px] sm:max-w-[246px] lg:w-auto lg:max-w-full">
                                {currentItem.challengeAddonOptions.map((i) => (
                                    <button
                                        onClick={() =>
                                            onOptionClicked(
                                                i.challengeAddonOptionId,
                                                i.displayText
                                            )
                                        }
                                        key={i.challengeAddonOptionId}
                                        className={`py-4 w-[70px] rounded-xl text-base focus:outline-none mr-3 mb-3 ${
                                            currentItem.challengeAddonOptionId ===
                                            i.challengeAddonOptionId
                                                ? 'text-white bg-yf-purple'
                                                : 'text-black bg-gray-300'
                                        }`}
                                    >
                                        {i.displayText}
                                    </button>
                                ))}
                            </div>
                        </div>
                    ) : null}

                    <div className="mb-8 flex justify-between items-center">
                        <p className="text-gray-600 text-lg">Quantity:</p>
                        <div>
                            <button
                                disabled
                                className={`py-4 w-[70px] rounded-xl text-base focus:outline-none mr-3 text-white bg-yf-purple`}
                            >
                                1
                            </button>
                        </div>
                    </div>

                    <button
                        onClick={() => onSaveRewardOptionsClicked()}
                        className={`w-full py-4 rounded-xl max-w-[450px] bg-yf-green text-white focus:outline-none ${
                            currentItem.challengeAddonOptions.length > 0 &&
                            currentItem.challengeAddonOptionId === null
                                ? 'bg-gray-700 cursor-not-allowed'
                                : 'bg-yf-green'
                        }`}
                    >
                        <div className="flex justify-between px-6">
                            <p className="font-medium">${currentItem.itemPrice}</p>
                            <p className="font-medium">
                                <span className="mr-1">Save Reward Options </span>
                                <i className="fal fa-arrow-right"></i>
                            </p>
                        </div>
                    </button>
                </div>
            </div>
            {/* <Tabs
                items={[
                    {
                        href: `/races/${encodeURIComponent(challengeId)}/${
                            currentItem.challengeAddonId
                        }`,
                        isActive: true,
                        text: 'About'
                    }
                ]}
            /> */}
        </div>
    )
}
